import { Component, OnInit } from "@angular/core";
import {
  HardBaseFormControlComponent,
  HardFormFieldTypeEnum,
  IHardFormField,
  IHardFormSelectParams,
} from "@hardcode-kz/ui";
import { ResourceManagementEndpoints } from "@app/shared/data-access/src/lib/resource-management/types/resource-management-endpoints";
import { IFormFieldFilter } from "@models/form/base-config";
import { IFleet } from "@app/shared/data-access/src/lib/resource-management/models/fleet";
import { IEquipmentTypeResponse } from "@dmms/shared/data-access/resource-management/models/equipment";

interface IFilter {
  fleets: IFleet[];
  equipmentTypes: IEquipmentTypeResponse[];
}

@Component({
  selector: "app-equipment-selection-with-filter",
  standalone: false,
  templateUrl: "./equipment-selection-with-filter.component.html",
  styleUrl: "./equipment-selection-with-filter.component.scss",
})
export class EquipmentSelectionWithFilterComponent
  extends HardBaseFormControlComponent
  implements OnInit
{
  innerConfig!: IHardFormField<IHardFormSelectParams>;

  readonly filterTemplateColumns = "1fr 1fr";

  readonly filterFields: IFormFieldFilter<IHardFormSelectParams>[] = [
    {
      name: "fleets",
      title: "dicTable.fleets",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: "api/v1/" + ResourceManagementEndpoints.FleetAccessible,
        multiple: true,
      },
    },
    {
      name: "equipmentTypes",
      title: "dicTable.equipmentTypes",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: "api/v1/" + ResourceManagementEndpoints.EquipmentType,
        multiple: true,
      },
    },
  ];

  ngOnInit() {
    this.innerConfig = {
      ...this.config,
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        ...this.config.params,
        dicType:
          "api/v1/" +
          ResourceManagementEndpoints.EquipmentBookingAuthorizationEquipment,
        fieldNames: ["tcoId"],
        multiple: true,
        queryParams: {},
      } as IHardFormSelectParams,
    };
  }

  onFilterChange(filters: IFilter): void {
    if (this.innerConfig.params) {
      this.innerConfig.params.queryParams = {
        fleetIds: filters?.fleets?.map((item) => item?.id),
        equipmentTypeIds: filters?.equipmentTypes?.map((item) => item?.id),
      };
    }
  }
}
